import React from "react";

function Agreement() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100%"
      data-name="Layer 1"
      viewBox="0 0 885 856.96"
    >
      <defs>
        <linearGradient
          id="431b905b-f630-4d26-9705-072736e3fa0a"
          x1="613.19"
          x2="613.19"
          y1="813.7"
          y2="105.57"
          gradientTransform="translate(-.86 -10.23)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="gray" stopOpacity="0.25"></stop>
          <stop offset="0.54" stopColor="gray" stopOpacity="0.12"></stop>
          <stop offset="1" stopColor="gray" stopOpacity="0.1"></stop>
        </linearGradient>
        <linearGradient
          id="82c9264e-9b45-4df5-9d25-f7dacbcab158"
          x1="613.84"
          x2="613.84"
          y1="152.52"
          y2="92.5"
          gradientTransform="translate(-140.84 19.9)"
          xlinkHref="#431b905b-f630-4d26-9705-072736e3fa0a"
        ></linearGradient>
        <linearGradient
          id="e7f96ace-9b05-41bf-887d-5e87841d3793"
          x1="613.84"
          x2="613.84"
          y1="104.78"
          y2="33.84"
          gradientTransform="rotate(-24.52 589.237 456.517)"
          xlinkHref="#431b905b-f630-4d26-9705-072736e3fa0a"
        ></linearGradient>
        <linearGradient
          id="0e5c1f30-7912-44d8-85da-be3b7e04fbbd"
          x1="440.4"
          x2="440.4"
          y1="329.87"
          y2="222.94"
          gradientTransform="translate(-61.32 78.01)"
          xlinkHref="#431b905b-f630-4d26-9705-072736e3fa0a"
        ></linearGradient>
        <linearGradient
          id="f5898732-89b1-47b9-bad4-993f506fb52e"
          x1="440.76"
          x2="440.76"
          y1="541.79"
          y2="434.85"
          gradientTransform="translate(26.6 58.74)"
          xlinkHref="#431b905b-f630-4d26-9705-072736e3fa0a"
        ></linearGradient>
        <linearGradient
          id="f9eac279-a8ac-46d5-97b7-7547b98d8743"
          x1="440.4"
          x2="440.4"
          y1="302"
          y2="249.51"
          gradientTransform="rotate(-24.52 462.547 807.555)"
          xlinkHref="#431b905b-f630-4d26-9705-072736e3fa0a"
        ></linearGradient>
        <linearGradient
          id="56bc9504-3ea8-4a78-ad29-d599ef16b1a5"
          x1="599.62"
          x2="599.62"
          y1="607.1"
          y2="100.78"
          xlinkHref="#431b905b-f630-4d26-9705-072736e3fa0a"
        ></linearGradient>
      </defs>
      <path
        fill="url(#431b905b-f630-4d26-9705-072736e3fa0a)"
        d="M356.07 95.34H868.5799999999999V803.47H356.07z"
        opacity="0.5"
        transform="rotate(-24.52 485.655 800.456)"
      ></path>
      <path
        fill="#fff"
        d="M361.51 100.79H860.98V793.27H361.51z"
        transform="rotate(-24.52 484.576 798.102)"
      ></path>
      <path
        fill="url(#82c9264e-9b45-4df5-9d25-f7dacbcab158)"
        d="M349.12 112.4H596.9V172.42000000000002H349.12z"
        transform="rotate(-24.52 346.323 493.463)"
      ></path>
      <path
        fill="url(#e7f96ace-9b05-41bf-887d-5e87841d3793)"
        d="M436.21 61.74c-17.4 7.94-24.92 28.82-16.79 46.64s28.83 25.83 46.23 17.89 24.92-28.82 16.79-46.64-28.83-25.83-46.23-17.89zm23.21 50.88a20.47 20.47 0 119.69-26.91 20.23 20.23 0 01-9.69 26.92z"
        transform="translate(-157.12 -20.92)"
      ></path>
      <path
        fill="#0a80ff"
        d="M351.19 112.55H593.75V169.93H351.19z"
        transform="rotate(-24.52 345.807 492.29)"
      ></path>
      <path
        fill="#0a80ff"
        d="M437.29 64.12a33.91 33.91 0 1044.92 16.78 33.91 33.91 0 00-44.92-16.78zm22.19 48.65a19.56 19.56 0 119.68-25.92 19.56 19.56 0 01-9.68 25.91z"
        transform="translate(-157.12 -20.92)"
      ></path>
      <path
        fill="url(#0e5c1f30-7912-44d8-85da-be3b7e04fbbd)"
        d="M325.61 300.95H432.55V407.89H325.61z"
        transform="rotate(-24.52 252.396 705.48)"
      ></path>
      <path
        fill="url(#f5898732-89b1-47b9-bad4-993f506fb52e)"
        d="M413.89 493.6H520.8299999999999V600.54H413.89z"
        transform="rotate(-24.52 340.697 898.134)"
      ></path>
      <path
        fill="#69f0ae"
        d="M329.52 304.86H428.63V403.97H329.52z"
        transform="rotate(-24.52 252.396 705.48)"
      ></path>
      <path
        fill="#0a80ff"
        d="M416.66 495.88H515.77V594.99H416.66z"
        transform="rotate(-24.52 339.533 896.507)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M471.46 260.92H607.31V270.40000000000003H471.46z"
        transform="rotate(-24.52 412.715 616.731)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M473.37 255.5H697.6800000000001V264.98H473.37z"
        transform="rotate(-24.52 458.86 611.29)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M479.98 271.71H688.49V281.19H479.98z"
        transform="rotate(-24.52 457.575 627.515)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M558.6 451.95H694.45V461.43H558.6z"
        transform="rotate(-24.52 499.85 807.758)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M560.51 446.52H784.8199999999999V456H560.51z"
        transform="rotate(-24.52 545.996 802.316)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M567.12 462.74H775.63V472.22H567.12z"
        transform="rotate(-24.52 544.71 818.542)"
      ></path>
      <path
        fill="url(#f9eac279-a8ac-46d5-97b7-7547b98d8743)"
        d="M199.04 337.46L222.26 345 229.9 300.31 241.2 303.4 228.49 358.65 193.47 343.3 199.04 337.46z"
      ></path>
      <path
        fill="#fff"
        d="M202 336.87L222.19 343.42 228.83 304.56 238.65 307.25 227.6 355.29 197.15 341.95 202 336.87z"
      ></path>
      <path
        fill="#fff"
        d="M289.68 529.08L309.87 535.63 316.51 496.77 326.33 499.46 315.28 547.5 284.83 534.16 289.68 529.08z"
      ></path>
      <path
        fill="#e0e0e0"
        d="M553.74 615.49H870.64V721.12H553.74z"
        transform="rotate(-24.52 585.523 1019.382)"
      ></path>
      <path
        fill="#0a80ff"
        d="M792.63 631.1c-11.08-3.16-22.42-2.56-25.95 10.11-1.19 4.27-1.33 10.9-5.91 13.1-6.74 3.24-14.87-3.24-20.72-5.88-10.9-4.92-22.09-1.57-28.4 8.77-3.2 5.24-4.57 11.27-5.66 17.24-.47 2.59-.53 5.79-1.62 8.23-2.09 4.67-8.63 4.25-12.92 4.07-.94 0-1.9-.11-2.86-.21a25.33 25.33 0 004.8-16.13c-.28-9.47-6.43-19.83-17.18-18.67-9.63 1-16.41 10.3-15.33 19.71.92 8 6.13 14.2 12.81 18-3.28 1.45-6.78 2.58-9.88 4.08a41.43 41.43 0 00-4.21 2.35c-9.37-4.52-21.68-5.37-30.11-.76-4.08 2.23-1.1 8.86 3 6.61 6.42-3.51 13.5-2.63 20.21-.4l.56.2a18.06 18.06 0 00-1.75 2.71c-3.79 7.36 0 19 9.22 19.8 13 1.11 13.61-16.07 6.55-22.91-.3-.29-.6-.57-.92-.84 2.92-1.41 6.08-2.47 8.87-3.66a36.89 36.89 0 006.9-3.84l.5.13c9.93 2.25 25.43 2.95 29-9.08 3.06-10.44 3.35-32.61 19.85-30.56 6.73.83 12.25 6 18.65 7.87 5.73 1.71 12.36 1.78 17.06-2.44 3.88-3.48 4.75-8.62 5.94-13.42.61-2.48 1.21-5.44 3.23-7.21 3.65-3.19 9.68-1.31 13.75-.15 4.45 1.26 7.03-5.54 2.52-6.82zm-129 84.59c-2.19 2.17-4.51.45-5.68-1.82-1.42-2.76-.81-5.48 1-7.91a13.74 13.74 0 01.95-1.14c4.33 2.8 7.87 6.81 3.77 10.87zm7.68-54c4.5-4.18 10.77-3.26 13.45 2.48s1.5 13.84-2.26 18.9a15.26 15.26 0 01-1.65 1.86 21.07 21.07 0 01-7.13-4.07c-5.32-4.8-8.33-13.67-2.37-19.2z"
        transform="translate(-157.12 -20.92)"
      ></path>
      <path
        fill="url(#56bc9504-3ea8-4a78-ad29-d599ef16b1a5)"
        d="M852.6 242.63l-80.72 31.47c-15.18-1.13-47.12-5.25-78.82-20.2-35.29-16.64-75.72-16.6-110 .83-79 1.89-122.48-8.23-145.68-17.81l6.12-12.56-81.82-31.9-204.56-91.68v375.76l71.59 31.9 38.4-92.12 84.33 39 16.19-41.14L423 455.27l3.77 3.17-5.19 5.39a27.06 27.06 0 000 37.21 24.64 24.64 0 0035.8 0l-2.84 3a27.06 27.06 0 000 37.21 24.64 24.64 0 0035.8 0l16.4-17.05-11.26 11.7a27.06 27.06 0 000 37.21 24.64 24.64 0 0035.8 0l16.19-16.83-6.81 7.08a18.9 18.9 0 000 26 17.21 17.21 0 0025 0l10.8-11.22c18.55 13.55 33.56 23.44 40.91 26C648 614.76 648 593.49 648 593.49c40.91 21.26 61.37-21.26 61.37-21.26 51.14 21.26 51.14-31.9 51.14-31.9 12.78 8.86 22 4.8 28.44-3 8.77-10.58 9.84-25.51 3.82-37.49l48.88-45.17 21.14 43.22 84.33-39 38.4 85.13 56.55-25.25V146.94z"
        transform="translate(-157.12 -20.92)"
      ></path>
      <path
        fill="#be7c5e"
        d="M681.9 418.48L592.88 497.6 523.65 369.02 681.9 329.46 681.9 418.48z"
      ></path>
      <path
        fill="#fda57d"
        d="M413.72 231.69s28.57 39.56 197.81 29.67l98.91 148.36 66.28 74.57c10.41 11.72 11 29.49.78 41.37-6.21 7.21-15.14 11-27.5 2.75 0 0 0 49.45-49.45 29.67 0 0-19.78 39.56-59.34 19.78 0 0 0 19.78-29.67 9.89S423.61 449.29 423.61 449.29l-69.23-49.45z"
        transform="translate(-157.12 -20.92)"
      ></path>
      <path
        fill="#be7c5e"
        d="M769.78 281.15s-42.74 0-85-19.19c-38.43-17.43-83.18-15.21-118.64 7.67-28.9 18.65-53.94 49.53-53.47 100.53 0 0 38.46 39.56 79.12-39.56h29.67s28.57 98.91 108.8 89 98.91-19.78 98.91-19.78z"
        transform="translate(-157.12 -20.92)"
      ></path>
      <rect
        width="48.96"
        height="76.93"
        x="456.83"
        y="463.57"
        fill="#be7c5e"
        rx="22.21"
        ry="22.21"
        transform="rotate(45 428 301.923)"
      ></rect>
      <rect
        width="48.96"
        height="76.93"
        x="424.96"
        y="426.21"
        fill="#be7c5e"
        rx="22.21"
        ry="22.21"
        transform="rotate(45 396.129 264.552)"
      ></rect>
      <rect
        width="48.96"
        height="83.92"
        x="498.86"
        y="487.27"
        fill="#be7c5e"
        rx="22.21"
        ry="22.21"
        transform="rotate(45 470.036 329.115)"
      ></rect>
      <rect
        width="34.19"
        height="55.95"
        x="540.04"
        y="526.26"
        fill="#be7c5e"
        rx="15.51"
        ry="15.51"
        transform="rotate(45 503.828 354.122)"
      ></rect>
      <path
        fill="#fff"
        d="M780.8 438.26L691.79 477.82 602.77 260.23 681.9 230.56 780.8 438.26z"
      ></path>
      <path
        fill="#fff"
        d="M108.25 388.81L197.26 428.37 286.28 210.78 207.15 181.1 108.25 388.81z"
      ></path>
      <path
        fill="#333"
        d="M9.34 92.09L207.15 181.1 78.58 477.82 9.34 448.15 9.34 92.09z"
      ></path>
      <path
        fill="#4d8af0"
        d="M879.71 141.54L681.9 230.56 810.48 527.27 879.71 497.6 879.71 141.54z"
      ></path>
    </svg>
  );
}

export default Agreement;
